export class ResetProjectBoardsList {
  public static readonly type = '[Project/Board/List] ResetProjectBoardsList';
}
